import ProjectBrowseProjectModule from './project-browse-project.module'

export default ProjectBrowseProjectModule
